import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { Store } from '@/shared/store';

export const useUserSuppliesData = () => {
    const state = useSelector((state: Store) => ({
        walletAddress: state.wallets.active.address,
        blockchainName: state.wallets.network,
        loading: state.supplies.userSuppliesLoading,
        userSupplies: state.supplies.userSupplies,
        hasUserSupplies: state.supplies.hasUserSupplies,
        agreements: state.agreements.lenderAgreements,
    }));

    return useMemo(() => state, [state]);
};
